// AlertBanner.tsx
import React from 'react';
import {Snackbar} from '@mui/material';
import MuiAlert, {AlertProps} from '@mui/material/Alert';
import {useAlert} from "../context/alert";
import AlertTitle from '@mui/material/AlertTitle';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert
        elevation={6}
        ref={ref}
        variant="filled"
        {...props} />;
});

const AlertBanner: React.FC = () => {
    const {alert, setAlert, info, setInfo, error, setError} = useAlert();

    const handleClose = () => {
        setAlert(null);
    };

    return (
        <Snackbar
            open={!!alert}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            {alert ? <Alert
                onClose={handleClose}
                severity={alert.severity}

            >
                {alert.severity === 'info' && <AlertTitle>Информация</AlertTitle>}
                {alert.severity === 'error' && <AlertTitle>Ошибка</AlertTitle>}
                {alert.message}
            </Alert> : undefined}
        </Snackbar>
    );
};

export default AlertBanner;